<h4>Patienten-Todos</h4>

<!-- some comment -->
<form class="form-vertical">
    <!-- add new reminder-->
    <div class="input-group">
        <input type="text" ng-model="vm.newreminder.label" class="form-control" id="newtodo" placeholder="Neues Todo">
        <div uib-dropdown class="input-group-btn" ng-class="gtClass">
            <button uib-dropdown-toggle type="button" class="btn btn-secondary">
                 <span ng-show="vm.newreminder.duestr">{{vm.newreminder.duestr}}</span>
                <span ng-hide="vm.newreminder.duestr">Fällig  </span><span class="caret"></span>
            </button>
            <!-- override bootstrap .dropdown-menu { min-width: 160px } -->
            <ul class="dropdown-menu" style="min-width: 0;">
                <li><a ng-click="vm.calcdue(0, 'Sofort')">Sofort</a></li>
                <li><a ng-click="vm.calcdue(14, '2 Wochen')">2 Wochen</a></li>
                <li><a ng-click="vm.calcdue(30, '1 Monat')">1 Monat</a></li>
                <li><a ng-click="vm.calcdue(90, '3 Monate')">3 Monate</a></li>
                <li><a ng-click="vm.calcdue(180, '6 Monate')">6 Monate</a></li>
                <li><a ng-click="vm.calcdue(365, '1 Jahr')">1 Jahr</a></li>
                <li><a ng-click="vm.calcdue(730, '2 Jahre')">2 Jahre</a></li>
                <li><a ng-click="vm.calcdue(1100, '3 Jahre')">3 Jahre</a></li>
            </ul>
            <button class="btn btn-success" type="submit" ng-click="vm.addTodoEntry()">
            <i class="fa fa-plus"></i>
            </button>
        </div>
    </div>
</form>

<!-- Show  Patientreminders-->
<div class="myscrollbox scrollwindow">
<form>
    <div class="form-group spacer-top" ng-repeat="item in vm.reminders | orderBy: ['done', 'due']">
        <label>
            <input type="checkbox"
                   ng-model="item.done"
                   ng-change="vm.save(item)"/>&nbsp;{{item.label}}, {{item.due | moment: 'l' }}</label>
    </div>
</form>
</div>
<div class="alert alert-info" ng-hide="vm.reminders.length > 0">Keine Todos</div>